






























































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import basicPage from "@/layouts/basicPage.vue";
import searchInput from "@/components/searchInput.vue";
import util from "@/lib/util";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import _ from "lodash";
import Util from "@/lib/util";
import AppConsts from "@/lib/appconst";

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};


const levelNames = {
    0: '低',
    1: '低',
    2: '中',
    3: '强'
}
const levelClass = {
    0: 'error',
    1: 'error',
    2: 'warning',
    3: 'success'
}
const levelColor = {
    0: '#ff0000',
    1: '#ff0000',
    2: '#ff7e05',
    3: '#52c41a'
}


@Component({
    components: {
        searchInput,
    }
})
export default class passwordModal extends basicPage {
    ModalText = '修改密码';
    visible = false;
    winWidth = 400;
    confirmLoading = false;
    form:any;

    state = {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000'
    }

    get passwordLevelClass () {
        return levelClass[this.state.passwordLevel]
    }
    get passwordLevelName () {
        return levelNames[this.state.passwordLevel]
    }
    get passwordLevelColor () {
        return levelColor[this.state.passwordLevel]
    }

    handlePasswordInputClick () {
        this.state.passwordLevelChecked = true
    }

    handlePasswordLevel (rule, value, callback) {
        let level = 0

        const password = this.form.getFieldValue('oldPassword');
        if (value && password && value.trim() === password.trim()) {
            callback(new Error('新密码不能与旧密码相同'))
        }

        // 判断这个字符串中有没有数字
        if (/[0-9]/.test(value)) {
            level++
        }
        // 判断字符串中有没有字母
        if (/[a-zA-Z]/.test(value)) {
            level++
        }
        // 判断字符串中有没有特殊符号
        if (/[^0-9a-zA-Z_]/.test(value)) {
            level++
        }
        this.state.passwordLevel = level
        this.state.percent = level * 30
        if (level >= 2) {
            if (level >= 3) {
                this.state.percent = 100
            }
            callback()
        } else {
            if (level === 0) {
                this.state.percent = 10
            }
            callback(new Error('密码强度不够'))
        }
    }

    handlePasswordCheck (rule, value, callback) {
        const password = this.form.getFieldValue('newPassword')
        console.log('value', value)
        if (value === undefined) {
            callback(new Error('请输入密码'))
        }
        if (value && password && value.trim() !== password.trim()) {
            callback(new Error('两次密码不一致'))
        }
        callback()
    }

    beforeCreate(){
        this.form = this.$form.createForm(this);
    }

    showModal() {
        this.visible = true;
    }
    handleOk(e) {
        let self = this;
        this.form.validateFields(async (err, values) => {
            if(err){
                return ;
            }
            ajaxHelperInstance.postM('/web/user/changePassword',values).then((rep)=>{
                let {data,message,errno} = rep.data;
                if(errno==0){
                    self.$message.success("密码修改成功!你需要重新登录");
                    self.handleCancel('');

                    setTimeout(()=>{
                        self.$store.commit('app/logout')
                        location.reload();
                    },1000)
                }else{
                    self.$message.info(message);
                }
            })
        })
    }
    handleCancel(e) {
        console.log('Clicked cancel button');
        this.visible = false;
        this.form.resetFields();
    }

    mounted() {
        // this.loadData();
    }
}
